import { render, staticRenderFns } from "./ProductRuleForm.vue?vue&type=template&id=3ed08a22&"
import script from "./ProductRuleForm.vue?vue&type=script&lang=js&"
export * from "./ProductRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports